import React from 'react'

import { getImgResizeUrl } from '~/shared/utils/urls'

import { Image } from './Avatar.styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'onError' implicitly has an 'any' ... Remove this comment to see the full error message
const Avatar = ({ src = '', alt = '', onError }) => (
  <Image
    // @ts-expect-error TS(2769) FIXME: No overload matches this call.
    src={getImgResizeUrl(src, 60)}
    alt={alt}
    onError={onError}
    draggable="false"
    onDragStart={(e) => e.preventDefault()}
  />
)

export default Avatar
